/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useDispatch } from "react-redux";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import findBatchesSlice from "./state/findBatches";
import createBatchReducer from "./state/createBatch";
import userGroupsSlice from "./state/userGroups";
import messagesReducer from "./state/messages";
import findProductsSlice from "./state/findProducts";
import getProductReducer from "./state/getProduct";

const store = configureStore({
  reducer: {
    userGroups: userGroupsSlice.reducer,
    messages: messagesReducer,
    batches: combineReducers({
      create: createBatchReducer,
      find: findBatchesSlice.reducer,
    }),
    products: combineReducers({
      get: getProductReducer,
      find: findProductsSlice.reducer,
    }),
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>(); // Export a hook that can be resused to resolve types

export default store;
